// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"cec2f0f5","726":"ca48e280","977":"ad61b3c1"}[chunkId] + ".chunk.js";
};